import { render } from "./CreateSecurityGroup.vue?vue&type=template&id=4ded779d&scoped=true&ts=true"
import script from "./CreateSecurityGroup.vue?vue&type=script&lang=ts"
export * from "./CreateSecurityGroup.vue?vue&type=script&lang=ts"

import "./CreateSecurityGroup.vue?vue&type=style&index=0&id=4ded779d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ded779d"]])

export default __exports__